export default __webpack_public_path__ + "assets/ico_why_della8_price-cc5bdb13.svg";